var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/dots_off"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.598 10.227a2.696 2.696 0 0 1-.01 3.807 2.697 2.697 0 0 1-3.807.01 2.696 2.696 0 0 1 .01-3.807 2.696 2.696 0 0 1 3.807-.01Zm7.445-7.446a2.697 2.697 0 0 1-.01 3.807 2.696 2.696 0 0 1-3.806.01 2.696 2.696 0 0 1 .01-3.807 2.696 2.696 0 0 1 3.806-.01Zm-.27 14.621a2.696 2.696 0 0 1-.01 3.807 2.696 2.696 0 0 1-3.806.01 2.696 2.696 0 0 1 .01-3.807 2.696 2.696 0 0 1 3.806-.01Zm7.446-7.445a2.696 2.696 0 0 1-.01 3.806 2.696 2.696 0 0 1-3.807.01 2.696 2.696 0 0 1 .01-3.807 2.696 2.696 0 0 1 3.807-.01Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsOff);
export default __webpack_public_path__ + "static/media/dots_off.0d9bfffbd1cc23953ec15267b9177db1.svg";
export { ForwardRef as ReactComponent };